import { supabase } from './supabase.js';

const STATUS_LABELS = {
  active: 'activar',
  paused: 'pausar',
  removed: 'retirar',
};

/**
 * Cambia estado de un listing vía Edge admin-actions (RLS admin).
 * @param {string} listingId
 * @param {'active'|'paused'|'removed'} status
 */
export async function adminSetListingStatus(listingId, status) {
  const id = String(listingId ?? '').trim();
  const st = String(status ?? '').trim();
  if (!id || !st) throw new Error('Datos de anuncio incompletos.');
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: { action: 'listing_set_status', payload: { listing_id: id, status: st } },
  });
  const serverMsg = data && typeof data === 'object' && data.message != null ? String(data.message) : '';
  if (error) {
    throw new Error(serverMsg || error.message || `No se pudo ${STATUS_LABELS[st] || 'actualizar'} el anuncio.`);
  }
  if (!data?.ok) {
    throw new Error(serverMsg || data?.error || `No se pudo ${STATUS_LABELS[st] || 'actualizar'} el anuncio.`);
  }
  return data;
}
